const targetHasDataClickHandler = (event) => {

    let el = event.target;

    while (el && el !== event.currentTarget) {

        if (el.getAttribute('data-click-handler')) {

            event.preventDefault();

            return true;

        }

        el = el.parentElement;

    }

    return false;

};

export default targetHasDataClickHandler;
